import { appPaths } from '@terminal/routes/app-paths';

export const WHATSAPP_ACCOUNT_SECTION = 'whatsapp';
export const WHATSAPP_ACCOUNT_SECTION_ID = 'alfred-whatsapp';

export const buildWhatsAppAccountLink = (returnTo?: string) => {
  const params = new URLSearchParams({
    section: WHATSAPP_ACCOUNT_SECTION,
  });

  if (returnTo?.startsWith(appPaths.alfred)) {
    params.set('returnTo', returnTo);
  }

  return `${appPaths.settings.account}?${params.toString()}#${WHATSAPP_ACCOUNT_SECTION_ID}`;
};

export const getSafeWhatsAppReturnPath = (
  returnTo: string | null
): string | null => (returnTo?.startsWith(appPaths.alfred) ? returnTo : null);
